import { call, put, takeEvery } from "redux-saga/effects";
import {  toast } from 'react-toastify';
import { GET_DETAILSUBVENDOR_FAILED, GET_DETAILSUBVENDOR_REQUESTED, GET_DETAILSUBVENDOR_SUCCESS, GET_SUBADDVENDOR_FAILED, GET_SUBADDVENDOR_REQUESTED, GET_SUBADDVENDOR_SUCCESS, GET_SUBVENDOR_FAILED, GET_SUBVENDOR_REQUESTED, GET_SUBVENDOR_SUCCESS, UPDATE_SUBADDVENDOR_FAILED, UPDATE_SUBADDVENDOR_REQUESTED, UPDATE_SUBADDVENDOR_SUCCESS } from "resources/actionTypes";
import { addSubVendorApi, detailSubVendorApi, subVendorApi, updateSubVendorApi } from "services/SubVendorService";
import { getSubVendor } from "redux/actions/UserSubVendor";
import store from "redux/store";
import { onLoaderTrigger } from "redux/actions/CommonAction";

function* fetchSubVendor(action) {
  try {
    const payload = action.payload || {}
    const userSubVendor = yield call(subVendorApi, payload);
    yield put({ type: GET_SUBVENDOR_SUCCESS, userSubVendor: userSubVendor });
  } catch (e) {
    yield put({ type: GET_SUBVENDOR_FAILED, message: e.message });
    toast.error(e.message || 'Get SubVendor Failed')
  }
}

export function* subVendorSaga() {
  yield takeEvery(GET_SUBVENDOR_REQUESTED, fetchSubVendor);
}

function* fetchSubAddVendor(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userAddSubVendor = yield call(addSubVendorApi, payload.userAddSubVendor);
  if(userAddSubVendor.success){
    yield put({ type: GET_SUBADDVENDOR_SUCCESS, userAddSubVendor: userAddSubVendor });
    toast.success(userAddSubVendor.message);
    store.dispatch(onLoaderTrigger(false));
    store.dispatch(getSubVendor({id: payload.userAddSubVendor.vendorId, status:'', page:"", pageSize:""}));
  }else{
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: GET_SUBADDVENDOR_FAILED, message: userAddSubVendor.message });
      toast.error(userAddSubVendor.message || 'Add Sub-Vendor failed');
  }
}
export function* addSubVendorSaga() {
  yield takeEvery(GET_SUBADDVENDOR_REQUESTED, fetchSubAddVendor);

}

function* fetchUpdateSubVendor(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userUpdateSubVendor = yield call(updateSubVendorApi, payload.userUpdateSubVendor);
  if(userUpdateSubVendor.success){
    yield put({ type: UPDATE_SUBADDVENDOR_SUCCESS, userUpdateSubVendor: userUpdateSubVendor });
    toast.success(userUpdateSubVendor.message);
    store.dispatch(onLoaderTrigger(false));
    if(payload?.userUpdateSubVendor?.id){
      store.dispatch(getSubVendor({id: payload.userUpdateSubVendor.id, status:'', page:"", pageSize:""}));
    }else{
      store.dispatch(getSubVendor({subVendorId: payload.userUpdateSubVendor.subVendorId, status:'', page:"", pageSize:""}));
    }
  }else{
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: UPDATE_SUBADDVENDOR_FAILED, message: userUpdateSubVendor.message });
      toast.error(userUpdateSubVendor.message || 'Update Sub-Vendor failed');
  }
}
export function* updateSubVendorSaga() {
  yield takeEvery(UPDATE_SUBADDVENDOR_REQUESTED, fetchUpdateSubVendor);

}

function* fetchDetailSubVendor(action) {
  try {
    const payload = action.payload || {}
    const userDetailSubVendor = yield call(detailSubVendorApi, payload);
    yield put({ type: GET_DETAILSUBVENDOR_SUCCESS, userDetailSubVendor: userDetailSubVendor });
  } catch (e) {
    yield put({ type: GET_DETAILSUBVENDOR_FAILED, message: e.message });
    toast.error(e.message || 'Get Subvendor Details Failed')
  }
}

export function* detailSubVendorSaga() {
  yield takeEvery(GET_DETAILSUBVENDOR_REQUESTED, fetchDetailSubVendor);
}
